module.exports = __webpack_public_path__ + "assets/fonts/uu5-glyphicons.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/uu5-glyphicons.svg?n7r5pz
// module id = 338
// module chunks = 0